import React from "react";
import styled from "styled-components";

// Ported from CRM (components/loader/LoaderSpinner). The ring is artwork, so the
// track and gradient keep CRM's own values rather than being tokenised.
const LoaderSpinner = (props: React.SVGProps<SVGSVGElement>) => (
  <LoaderSvg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48 0C21.49 0 0 21.49 0 48C0 74.51 21.49 96 48 96C74.51 96 96 74.51 96 48C96 21.49 74.51 0 48 0ZM48 92C23.7 92 4 72.3 4 48C4 23.7 23.7 4 48 4C72.3 4 92 23.7 92 48C92 72.3 72.3 92 48 92Z"
      fill="#E7E8EF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48 2.04982C48 3.10982 48.82 3.99982 49.88 4.03982C73.31 5.01982 92 24.3298 92 47.9998C92 71.6698 73.31 90.9798 49.88 91.9598C48.82 91.9998 48 92.8998 48 93.9498C48 95.0898 48.96 95.9998 50.1 95.9498C75.64 94.8498 96 73.7998 96 47.9998C96 22.1998 75.64 1.13982 50.1 0.0498178C48.96 -0.000182226 48 0.909818 48 2.04982Z"
      fill="url(#tp_loader_gradient)"
    />
    <defs>
      <linearGradient
        id="tp_loader_gradient"
        x1="47.5"
        y1="-1"
        x2="48"
        y2="96"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5323D9" />
        <stop offset="0.989796" stopColor="#5627DA" stopOpacity="0" />
      </linearGradient>
    </defs>
  </LoaderSvg>
);

export default LoaderSpinner;

export const LoaderSvg = styled.svg`
  width: 6rem;
  height: 6rem;
  display: inline-block;
  box-sizing: border-box;
  animation: tp-loader-rotation 2s linear infinite;

  @keyframes tp-loader-rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
